import type { AuthStateType } from '@/shared/authentication/utils/constants';

import { permissionGroups, type PermissionGroup } from './permissionGroups';

export type AllowEntry = AuthStateType | PermissionGroup;

export function resolveRoles(entries: readonly AllowEntry[]): AuthStateType[] {
  const resolved: AuthStateType[] = [];
  for (const entry of entries) {
    if (entry in permissionGroups) {
      resolved.push(...permissionGroups[entry as PermissionGroup]);
    } else {
      resolved.push(entry as AuthStateType);
    }
  }
  return resolved;
}

export function isAuthorized(role: AuthStateType, allow: readonly AllowEntry[]): boolean {
  return resolveRoles(allow).includes(role);
}
